// extracted by mini-css-extract-plugin
export default {"allCourses":"AllCourses_allCourses__bcKCS","container":"AllCourses_container__5IfyL","allCourses_title":"AllCourses_allCourses_title__s6ajz"};